<template>
    <drawer-layout>
        <main class="bible">
            <data-gathering-header
                :title="$t('data_gatherings.recu').toString()"
                :breadcrumbs-items="breadcrumbsItems"
            />

            <data-gathering-card-list />
        </main>
    </drawer-layout>
</template>

<script>
import DrawerLayout from "@/Shared/DrawerLayout";
import DataGatheringCardList from "@/Shared/DathaGatherings/Common/DataGatheringCardList";
import IndexPage from "@/Pages/DataGathering/IndexPage";
import {i18n} from "@/i18n";
import DataGatheringHeader from "@/Shared/DathaGatherings/Common/DataGatheringHeader";

export default {
    components: {DataGatheringHeader, DataGatheringCardList, DrawerLayout},

    mixins: [IndexPage],

    props: {

    },

    data() {
        return {
            breadcrumbsItems: [
                {
                    text: i18n.t('data_gatherings.data_sources'),
                    disabled: true,
                },
                {
                    text: i18n.t('data_gatherings.bibles'),
                    disabled: true,
                    href: route('bibles.index'),
                },
            ],
        };
    },

    mounted() {
        this.setCommonRoute('explore_records', 'bibles.records');
    },
};
</script>

<style scoped>

</style>
